
<template>
  <div class="game_list">
    <div :class="['content_box',list.length<2?'special':'', ]">
      <div class="game_item" v-for="(item,index) in list" :key="index">
        <div v-if="maps[item.folder]!==item.version" :class="[maps[item.folder]==item.version?'':'namebox__refresh']">New</div>
        <div class="imgbox cursor">
          <img @click="goplay(item.folder,item.subType,item.version,index)" :src="item.imgUrl" alt>
        </div>
        <div :class="['namebox']">
          <span class="gameName">{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class="title" v-if="!list.length && !loadErrorShow">暂无学具</div>
    <loadError
      textColor="#0087AD"
      :loadErrorText="loadErrorText"
      @loadAgain="getList"
      v-if="loadErrorShow"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import loadError from "../../basic/loadError";
import common from "common";
if(LIMI_ENV==="electron"){
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "course_list",
  data() {
    return {
      loadErrorShow: false,
      loadErrorText: "游戏信息获取失败，请点击按钮重新加载～",
      maps: {},
      allList: {},
      interval:null
    };
  },
  components: {
    loadError
  },
  computed: {
    ...mapState(['lastGrade',"phone"]),
    list() {
      this.$nextTick(this.autoScroll);
      return this.allList[this.lastGrade] || []
    }
  },
  created() {
    this.maps = common.get("gamelist") || {};
    this.getList();
  },
  mounted() {},
  methods: {
    ...mapActions(["getClassPageBaseData"]),
    autoScroll(){
      clearInterval(this.interval);
      const gameListScroll = common.getSession("gameListScroll") || {};
      if(!gameListScroll[this.lastGrade]){
        gameListScroll[this.lastGrade] = true;
        common.setSession("gameListScroll",gameListScroll)
        const gameListDom = document.querySelector(".game_list");
        const contentBoxDom = document.querySelector(".content_box");
        const cH = contentBoxDom.offsetHeight;
        const gH = (gameListDom.clientHeight-190);
        let t = cH - gH;
        if(cH>gH && t>170){
          gameListDom.scrollTop = t;
          setTimeout(()=>{
            this.interval = setInterval(() => {
              gameListDom.scrollTop = t-=10;
              if(t<=0)clearInterval(this.interval)
            }, 5);
          },500)
        }else{
          gameListDom.scrollTop = 0;
        }
      }
    },
    getList() {
      const data = common.getSession('randerGameList') || {};
      if(data.title){
        this.updateData(data)
        return;
      }
      this.getClassPageBaseData({data:{
        client:common.client,
        version: common.version,
        username:this.phone
      },config:{
        needLoading:true
      }}).then(({ res, ok }) => {
        if (ok) {
          if(!res.courseWareGame.title)return;
          this.updateData(res.courseWareGame);
          common.setSession('randerGameList',res.courseWareGame);
        } else {
          this.loadErrorShow = true;
        }
      }).catch(() => {
        this.loadErrorShow = true;
      });
    },
    updateData(data){
      this.loadErrorShow = false;
      this.allList = data.list;
      this.$parent.title=data.title;
      this.$parent.gradeList=Object.keys(data.list);
      LIMI_ENV==="electron" && this.download();
    },
    download(){
      let arr = [];
      for(let key in this.allList){
        this.allList[key].forEach((v)=>{
          if(arr.includes(v.folder))return;
          arr.push(v.folder)
          ipc.send('loadKeJian',{
            url:v.zipUrl
          })
        })
      }
    },
    goplay(folder, sub_type, version, index) {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLittleGameStar",
        data: {
          game_id: sub_type
        }
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventGameCard",
        data: {
          game_id: sub_type,
          index: index + 1,
          action: "enter"
        }
      });
      this.maps[folder] = version;
      common.set("gamelist", this.maps);
      this.$router.push({
        path: "/playgame",
        query: {
          index: folder
        }
      });
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
::-webkit-scrollbar {
  width: 0px;
}

.game_list {
  width: 100%;
  overflow-y: scroll;
  margin-top: 70px;
  height: 100%;
  position: relative;
  padding-bottom: 120px;
  .title{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    width: 100%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content_box {
    width: 720px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    margin-top: 67px;
    justify-content: flex-start;
    .game_item {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 192px;
      height: 275px;
      position: relative;
      .imgbox {
        height: 153px;
        width: 153px;
        overflow: hidden;
        border-radius: 50%;
        border: 6px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 153px;
          min-width: 153px;
          color: #003057;
          text-align: center;
        }
      }
      .namebox {
        position: relative;
        margin-top: -35px;
        width: 120px;
        height: 40px;
        border-radius: 20px;
        background: #fff;
        .gameName {
          font-size: 20px;
          line-height: 40px;
          color: #004466;
          font-weight: 500;
        }
      }
      .namebox__refresh {
        position: absolute;
        color: #fff;
        top:5px;
        right: 27px;
        font-size: 15px;
        padding: 0 5px;
        border: 2px solid #ffffff;
        background: #f15656;
        border-radius: 12px;
      }
    }
    .game_item:nth-child(3n + 2) {
      margin: 0 72px;
    }
  }
  .special {
    display: flex;
    justify-content: space-around;
    .game_item:nth-child(3n + 2) {
      margin: 0;
    }
  }
  @media screen and (min-width: 1921px) {
    .content_box {
      width: 841px !important;
      .content:nth-child(3n + 2) {
        margin: 0 183px !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/game/game_list.vue